import { sizes } from '../../styled-components';
export const MigrosCorporateTheme = {
  name: 'Migros Corporate',
  themeId: 'migrosCorporate',
  colors: {
    brand: {
      text: {
        90: '#737373'
      }
    }
  },
  spacings: {
    xtiny: '4px',
    xsmall: '8px',
    small: '10px',
    medium: '14px',
    large: '22px',
    xlarge: '58px',
    xxlarge: '64px',
    huge: '72px'
  },
  fonts: {
    families: {
      heading: '"Helvetica Now Display", "Helvetica", arial, sans-serif',
      subHeading: '"Helvetica Now Micro", "Helvetica", arial, sans-serif',
      articleHeading: '"Helvetica Now Display", "Helvetica", arial, sans-serif',
      text: '"Helvetica Now Text", "Helvetica", arial, sans-serif'
    },
    weights: {
      semiBold: 500,
      bold: 700
    },
    sizes: {
      text: {
        tiny: '12px',
        xtiny: '13px',
        xsmall: '14px',
        modest: '15px',
        small: '16px',
        medium: '18px',
        large: '20px',
        xlarge: '24px',
        huge: '28px'
      },
      heading: {
        tiny: '18px',
        xtiny: '19px',
        xsmall: '20px',
        modest: '22px',
        small: '24px',
        medium: '28px',
        large: '32px',
        xlarge: '36px',
        huge: '40px'
      }
    }
  },
  durations: {
    default: '400ms'
  },
  easings: {
    default: 'cubic-bezier(0.65, 0.05, 0.36, 1)'
  },
  lineHeight: {
    none: '1.1',
    tight: '1.3',
    normal: '1.5'
  },
  borderRadiuses: {
    medium: '8px'
  },
  mixins: {
    getTypographicStyles: ({
      value
    }) => {
      var _theme$fonts, _theme$fonts$families, _theme$fonts2, _theme$fonts2$weights, _theme$lineHeight, _theme$fonts3, _theme$fonts3$sizes, _theme$fonts3$sizes$h, _theme$fonts4, _theme$fonts4$familie, _theme$fonts5, _theme$fonts5$weights, _theme$lineHeight2, _theme$fonts6, _theme$fonts6$sizes, _theme$fonts6$sizes$h, _theme$fonts7, _theme$fonts7$sizes, _theme$fonts7$sizes$h, _theme$fonts8, _theme$fonts8$sizes, _theme$fonts8$sizes$h, _theme$fonts9, _theme$fonts9$familie, _theme$fonts10, _theme$fonts10$weight, _theme$lineHeight3, _theme$fonts11, _theme$fonts11$sizes, _theme$fonts11$sizes$, _theme$fonts12, _theme$fonts12$sizes, _theme$fonts12$sizes$, _theme$fonts13, _theme$fonts13$famili, _theme$fonts14, _theme$fonts14$weight, _theme$lineHeight4, _theme$fonts15, _theme$fonts15$sizes, _theme$fonts15$sizes$, _theme$fonts16, _theme$fonts16$sizes, _theme$fonts16$sizes$, _theme$fonts17, _theme$fonts17$famili, _theme$fonts18, _theme$fonts18$weight, _theme$fonts19, _theme$fonts19$sizes, _theme$fonts19$sizes$;
      const theme = MigrosCorporateTheme;
      switch (value) {
        case 'display2':
          return `
            font-family: ${(_theme$fonts = theme.fonts) === null || _theme$fonts === void 0 ? void 0 : (_theme$fonts$families = _theme$fonts.families) === null || _theme$fonts$families === void 0 ? void 0 : _theme$fonts$families.heading};  
            font-weight: ${(_theme$fonts2 = theme.fonts) === null || _theme$fonts2 === void 0 ? void 0 : (_theme$fonts2$weights = _theme$fonts2.weights) === null || _theme$fonts2$weights === void 0 ? void 0 : _theme$fonts2$weights.bold};
            line-height: ${(_theme$lineHeight = theme.lineHeight) === null || _theme$lineHeight === void 0 ? void 0 : _theme$lineHeight.none};
            letter-spacing: -0.2px;
            font-size: 42px;
            @media screen and (${sizes.largeDesktop}) {
              font-size: 48px;
            }
            @media screen and (${sizes.tabletAndDown}) {
              font-size: ${(_theme$fonts3 = theme.fonts) === null || _theme$fonts3 === void 0 ? void 0 : (_theme$fonts3$sizes = _theme$fonts3.sizes) === null || _theme$fonts3$sizes === void 0 ? void 0 : (_theme$fonts3$sizes$h = _theme$fonts3$sizes.heading) === null || _theme$fonts3$sizes$h === void 0 ? void 0 : _theme$fonts3$sizes$h.xlarge};
            }
          `;
        case 'display3':
          return `
            font-family: ${(_theme$fonts4 = theme.fonts) === null || _theme$fonts4 === void 0 ? void 0 : (_theme$fonts4$familie = _theme$fonts4.families) === null || _theme$fonts4$familie === void 0 ? void 0 : _theme$fonts4$familie.heading};
            font-weight: ${(_theme$fonts5 = theme.fonts) === null || _theme$fonts5 === void 0 ? void 0 : (_theme$fonts5$weights = _theme$fonts5.weights) === null || _theme$fonts5$weights === void 0 ? void 0 : _theme$fonts5$weights.bold};
            line-height: ${(_theme$lineHeight2 = theme.lineHeight) === null || _theme$lineHeight2 === void 0 ? void 0 : _theme$lineHeight2.tight};
            letter-spacing: 0;
            font-size: ${(_theme$fonts6 = theme.fonts) === null || _theme$fonts6 === void 0 ? void 0 : (_theme$fonts6$sizes = _theme$fonts6.sizes) === null || _theme$fonts6$sizes === void 0 ? void 0 : (_theme$fonts6$sizes$h = _theme$fonts6$sizes.heading) === null || _theme$fonts6$sizes$h === void 0 ? void 0 : _theme$fonts6$sizes$h.medium};
            @media screen and (${sizes.largeDesktop}) {
              font-size: ${(_theme$fonts7 = theme.fonts) === null || _theme$fonts7 === void 0 ? void 0 : (_theme$fonts7$sizes = _theme$fonts7.sizes) === null || _theme$fonts7$sizes === void 0 ? void 0 : (_theme$fonts7$sizes$h = _theme$fonts7$sizes.heading) === null || _theme$fonts7$sizes$h === void 0 ? void 0 : _theme$fonts7$sizes$h.large};
            }
            @media screen and (${sizes.tabletAndDown}) {
              font-size: ${(_theme$fonts8 = theme.fonts) === null || _theme$fonts8 === void 0 ? void 0 : (_theme$fonts8$sizes = _theme$fonts8.sizes) === null || _theme$fonts8$sizes === void 0 ? void 0 : (_theme$fonts8$sizes$h = _theme$fonts8$sizes.heading) === null || _theme$fonts8$sizes$h === void 0 ? void 0 : _theme$fonts8$sizes$h.small};
            }
          `;
        case 'headline1':
          return `
            font-family: ${(_theme$fonts9 = theme.fonts) === null || _theme$fonts9 === void 0 ? void 0 : (_theme$fonts9$familie = _theme$fonts9.families) === null || _theme$fonts9$familie === void 0 ? void 0 : _theme$fonts9$familie.heading};
            font-weight: ${(_theme$fonts10 = theme.fonts) === null || _theme$fonts10 === void 0 ? void 0 : (_theme$fonts10$weight = _theme$fonts10.weights) === null || _theme$fonts10$weight === void 0 ? void 0 : _theme$fonts10$weight.bold};
            line-height: ${(_theme$lineHeight3 = theme.lineHeight) === null || _theme$lineHeight3 === void 0 ? void 0 : _theme$lineHeight3.normal};
            letter-spacing: -0.2px;
            font-size: ${(_theme$fonts11 = theme.fonts) === null || _theme$fonts11 === void 0 ? void 0 : (_theme$fonts11$sizes = _theme$fonts11.sizes) === null || _theme$fonts11$sizes === void 0 ? void 0 : (_theme$fonts11$sizes$ = _theme$fonts11$sizes.text) === null || _theme$fonts11$sizes$ === void 0 ? void 0 : _theme$fonts11$sizes$.xlarge};
            @media screen and (${sizes.tabletAndDown}) {
              font-size: ${(_theme$fonts12 = theme.fonts) === null || _theme$fonts12 === void 0 ? void 0 : (_theme$fonts12$sizes = _theme$fonts12.sizes) === null || _theme$fonts12$sizes === void 0 ? void 0 : (_theme$fonts12$sizes$ = _theme$fonts12$sizes.text) === null || _theme$fonts12$sizes$ === void 0 ? void 0 : _theme$fonts12$sizes$.large};
            }
          `;
        case 'text':
          return `
            font-family: ${(_theme$fonts13 = theme.fonts) === null || _theme$fonts13 === void 0 ? void 0 : (_theme$fonts13$famili = _theme$fonts13.families) === null || _theme$fonts13$famili === void 0 ? void 0 : _theme$fonts13$famili.text};
            font-weight: ${(_theme$fonts14 = theme.fonts) === null || _theme$fonts14 === void 0 ? void 0 : (_theme$fonts14$weight = _theme$fonts14.weights) === null || _theme$fonts14$weight === void 0 ? void 0 : _theme$fonts14$weight.regular};
            line-height: ${(_theme$lineHeight4 = theme.lineHeight) === null || _theme$lineHeight4 === void 0 ? void 0 : _theme$lineHeight4.normal};
            font-size: ${(_theme$fonts15 = theme.fonts) === null || _theme$fonts15 === void 0 ? void 0 : (_theme$fonts15$sizes = _theme$fonts15.sizes) === null || _theme$fonts15$sizes === void 0 ? void 0 : (_theme$fonts15$sizes$ = _theme$fonts15$sizes.text) === null || _theme$fonts15$sizes$ === void 0 ? void 0 : _theme$fonts15$sizes$.medium};
            @media screen and (${sizes.tabletAndDown}) {
              font-size: ${(_theme$fonts16 = theme.fonts) === null || _theme$fonts16 === void 0 ? void 0 : (_theme$fonts16$sizes = _theme$fonts16.sizes) === null || _theme$fonts16$sizes === void 0 ? void 0 : (_theme$fonts16$sizes$ = _theme$fonts16$sizes.text) === null || _theme$fonts16$sizes$ === void 0 ? void 0 : _theme$fonts16$sizes$.small};
            }
          `;
        case 'body2emphasis':
          return `
            font-family: ${(_theme$fonts17 = theme.fonts) === null || _theme$fonts17 === void 0 ? void 0 : (_theme$fonts17$famili = _theme$fonts17.families) === null || _theme$fonts17$famili === void 0 ? void 0 : _theme$fonts17$famili.subHeading};
            font-weight: ${(_theme$fonts18 = theme.fonts) === null || _theme$fonts18 === void 0 ? void 0 : (_theme$fonts18$weight = _theme$fonts18.weights) === null || _theme$fonts18$weight === void 0 ? void 0 : _theme$fonts18$weight.bold};
            font-size: ${(_theme$fonts19 = theme.fonts) === null || _theme$fonts19 === void 0 ? void 0 : (_theme$fonts19$sizes = _theme$fonts19.sizes) === null || _theme$fonts19$sizes === void 0 ? void 0 : (_theme$fonts19$sizes$ = _theme$fonts19$sizes.text) === null || _theme$fonts19$sizes$ === void 0 ? void 0 : _theme$fonts19$sizes$.tiny};
          `;
        default:
          console.warn('typographic value not found');
          return ``;
      }
    },
    getArrowGap: () => {
      return `
        gap: 10px;
        @media screen and (${sizes.largeDesktop}) {
          gap: 12px;
        }
        @media screen and (${sizes.tabletAndDown}) {
          gap: 8px;
        }
      `;
    }
  }
};